import Option from "../../../../Models/forms/Option";

export default (): Option[] =>
  ["Agent", "Broker", "Agent and Broker"].map((option) => ({
    value: option,
    label: option,
  }));
